import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowHideButton',
  props: {
    showMore: { type: Boolean },
    disabled: { type: Boolean },
    isDropDownVariant: { type: Boolean, default: true },
    showMoreLabel: {},
    showLessLabel: {},
    appendClass: {},
    hideLabel: { type: Boolean },
    showMorePreCopy: {}
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const buttonLabel = computed(() =>
  props.hideLabel ? '' : props.showMore ? (props.showLessLabel ?? 'Show less') : (props.showMoreLabel ?? 'Show more')
);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.appendClass ?? ''} flex flex-col md:flex-row mt-4 items-start gap-2`)
  }, [
    (_ctx.showMorePreCopy)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(_ctx.isDropDownVariant ? 'text-base' : 'text-sm')
        }, _toDisplayString(_ctx.showMorePreCopy), 3))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      "aria-label": "Show or hide button",
      type: "button",
      class: _normalizeClass(["show-hide flex items-center", _ctx.isDropDownVariant ? 'text-base-bold' : 'text-sm-bold']),
      disabled: _ctx.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
    }, [
      _createTextVNode(_toDisplayString(buttonLabel.value) + " ", 1),
      (buttonLabel.value.length > 0 && _ctx.isDropDownVariant)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["bg-icon-chevron-down icon w-[12px] h-[7px] ml-2 bg-no-repeat bg-contain", _ctx.showMore ? 'transform rotate-180' : ''])
          }, null, 2))
        : _createCommentVNode("", true),
      (buttonLabel.value.length == 0 && _ctx.isDropDownVariant)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["bg-icon-chevron-down-lg icon w-4 h-4 ml-2 bg-no-repeat bg-contain", _ctx.showMore ? 'transform rotate-180' : ''])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 2))
}
}

})